
import FeedbackItemService from '../../services/feedbackItems'

export const state = {}

export const mutations = {}

export const getters = {}

export const actions = {
  // eslint-disable-next-line no-unused-vars
  init({ state, dispatch }) {},

  // eslint-disable-next-line no-unused-vars
  getFeedbackItems ({ commit }, params) {

    return new Promise((resolve, reject) => {
      FeedbackItemService.getFeedbackItems(params).then(response => {
        resolve(response.data)
      })
      .catch(error => { reject(error) })
    });
  },

  // eslint-disable-next-line no-unused-vars
  getFeedbackItemsSummary ({ commit }, params) {

    return new Promise((resolve, reject) => {
      FeedbackItemService.getFeedbackItemsSummary(params).then(response => {
        resolve(response.data)
      })
      .catch(error => { reject(error) })
    });
  },

  // eslint-disable-next-line no-unused-vars
  deleteFeedbackItem ({ commit }, feedbackItemId) {

    return new Promise((resolve, reject) => {
      FeedbackItemService.deleteFeedbackItem(feedbackItemId).then(response => {
        resolve(response.data)
      })
      .catch(error => { reject(error) })
    });
  }
}
